<!-- 我的文档更多操作 -->
<template>
  <div>
    <!-- 系统文件夹操作菜单 -->
    <van-action-sheet v-model="showSysFolder" :actions="sysFolderMoreList" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectSysFolder" />
    <!-- 文件夹操作菜单 -->
    <van-action-sheet v-model="showFolder" :actions="folderMoreList" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFolder" />
    <!-- 文件操作菜单 -->
    <van-action-sheet v-model="showFile" :actions="fileMoreList" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFile" />

    <!-- 删除弹框 -->
    <van-popup v-model="showDel" round @close="showDel = false">
      <div class="modalStyle">
        <div class="text">确定要删除该文件吗？</div>
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="showDel = false" />
          <van-button text="确认" type="info" round @click="confirmDel" />
        </div>
      </div>
    </van-popup>
    <!-- 重命名弹框 -->
    <van-popup v-model="renameShow" round @close="renameShow = false">
      <div class="modalRenameStyle">
        <div class="text">重命名</div>
        <van-field v-model="renameValue" placeholder="请输入" clearable class="input" />
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="renameShow = false" />
          <van-button text="确认" type="info" round @click="confirmRename" />
        </div>
      </div>
    </van-popup>
    <!-- 属性弹框 -->
    <van-popup v-model="attributeShow" position="bottom">
      <div class="attributeContent">
        <div class="attributeItem">
          <span>文件大小：</span>
          <span class="attributeItemData">{{ Pitem.isFolder === 1 ? "--" : Pitem.fileSize }}</span>
        </div>
        <div class="attributeItem">
          <span>修改人：</span>
          <span class="attributeItemData">{{ Pitem.checkInUser || "--" }}</span>
        </div>
        <div class="attributeItem">
          <span>修改时间：</span>
          <span class="attributeItemData">{{ Pitem.checkInDate || "--" }}</span>
        </div>
        <div class="attributeItem">
          <span>备注：</span>
          <span class="attributeItemData">{{ Pitem.remark || "--" }}</span>
        </div>
      </div>
      <div class="attributeClose" @click="attributeClose">取消</div>
    </van-popup>
    <!-- 移动到弹框 -->
    <van-popup v-model="moveShow" position="bottom" :overlay="false" class="moveToPopup">
      <div class="moveTo">
        <van-button text="取消" type="info" round plain @click="moveCancel" />
        <van-button text="确认" type="info" round @click="moveConfirm" />
      </div>
    </van-popup>
    <!-- 复制到弹框 -->
    <van-popup v-model="copyShow" position="bottom" :overlay="false" class="moveToPopup">
      <div class="moveTo">
        <van-button text="取消" type="info" round plain @click="copyCancel" />
        <van-button text="确认" type="info" round @click="copyConfirm" />
      </div>
    </van-popup>
    <!-- 分享弹框 -->
    <van-popup v-model="shareShow" position="bottom" round @open="shareOpen" @close="shareShow = false">
      <div class="shareStyle">
        <qrcode v-if="shareShow" ref="qrcode"></qrcode>
        <van-button type="info" round plain @click="saveQrcode">保存图片</van-button>
        <div class="linkText">{{ "链接：" + shareLink.url }}</div>
        <span class="linkBtn" @click="copyUrl(shareLink.url)">复制链接</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { downloadFile, downloadUrltoken, downloadFileShowPrompt } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import getDateTime from "@/CommonDP/utils/getDateTime.js";
import qrcode from "../../components/qrcode.vue";

export default {
  components: { qrcode },
  props: ["currentFolderId"],
  data() {
    return {
      // 系统文件夹操作菜单
      sysFolderMoreList: [],
      sysFolderPriviList: [
        // { name: "下载", Privi: this.$allPerms.MYDOC_DOWN },
        { name: "分享", Privi: this.$allPerms.MYDOC_SHARE },
        { name: "属性", Privi: "" },
        { name: "添加收藏", Privi: "" }
      ],
      // 文件夹操作菜单
      folderMoreList: [],
      folderPriviList: [
        { name: "删除", Privi: this.$allPerms.MYDOC_DELE },
        { name: "移动到", Privi: this.$allPerms.MYDOC_MOVE },
        { name: "复制到", Privi: this.$allPerms.MYDOC_COPY },
        { name: "重命名", Privi: "" },
        // { name: "下载", Privi: this.$allPerms.MYDOC_DOWN },
        { name: "分享", Privi: this.$allPerms.MYDOC_SHARE },
        { name: "属性", Privi: "" },
        { name: "添加收藏", Privi: "" }
      ],
      // 文件操作菜单
      fileMoreList: [],
      filePriviList: [
        { name: "删除", Privi: this.$allPerms.MYDOC_DELE },
        { name: "移动到", Privi: this.$allPerms.MYDOC_MOVE },
        { name: "复制到", Privi: this.$allPerms.MYDOC_COPY },
        { name: "重命名", Privi: "" },
        // { name: "下载", Privi: this.$allPerms.MYDOC_DOWN },
        { name: "分享", Privi: this.$allPerms.MYDOC_SHARE },
        { name: "属性", Privi: "" },
        { name: "添加收藏", Privi: "" }
      ],
      showSysFolder: false,
      showFolder: false,
      showFile: false,
      Pitem: {}, // 当前操作的文档
      selectArr: [], // 选中的文档

      showDel: false, // 删除弹框
      renameShow: false, // 重命名弹框
      renameValue: "", // 重命名-名称
      attributeShow: false, // 属性弹框
      shareShow: false, // 分享弹框
      shareLink: {}, // 分享链接
      moveShow: false, // 移动到弹框
      copyShow: false // 复制到弹框
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    })
  },
  mounted() {},
  methods: {
    // 设置系统文件夹权限
    setSysFolderPrivi(items) {
      this.Pitem = items || {};
      this.sysFolderMoreList = this.sysFolderPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.closeMoveCopy();
      this.showSysFolder = true;
    },
    // 设置文件夹权限
    setFolderPrivi(items) {
      this.Pitem = items || {};
      this.folderMoreList = this.folderPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.closeMoveCopy();
      this.showFolder = true;
    },
    // 设置文件权限
    setFilePrivi(items) {
      this.Pitem = items || {};
      this.fileMoreList = this.filePriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.closeMoveCopy();
      this.showFile = true;
    },
    // 关闭事件
    close() {
      this.showSysFolder = false;
      this.showFolder = false;
      this.showFile = false;
    },
    // 关闭移动、复制
    closeMoveCopy() {
      this.moveShow = false;
      this.copyShow = false;
    },

    // 系统文件夹菜单事件
    selectSysFolder(val) {
      if (val.name == "下载") this.downloadDoc(this.Pitem);
      if (val.name == "分享") this.shareDoc();
      if (val.name == "属性") this.queryAttribute();
      if (val.name == "添加收藏") this.addCollect();
    },
    // 文件夹菜单事件
    selectFolder(val) {
      if (val.name == "删除") this.deleteRow();
      if (val.name == "移动到") this.moveTo();
      if (val.name == "复制到") this.copyTo();
      if (val.name == "重命名") this.rename();
      if (val.name == "下载") this.downloadDoc(this.Pitem);
      if (val.name == "分享") this.shareDoc();
      if (val.name == "属性") this.queryAttribute();
      if (val.name == "添加收藏") this.addCollect();
    },
    // 文件菜单事件
    selectFile(val) {
      if (val.name == "删除") this.deleteRow();
      if (val.name == "移动到") this.moveTo();
      if (val.name == "复制到") this.copyTo();
      if (val.name == "重命名") this.rename();
      if (val.name == "下载") this.downloadDoc(this.Pitem);
      if (val.name == "分享") this.shareDoc();
      if (val.name == "属性") this.queryAttribute();
      if (val.name == "添加收藏") this.addCollect();
    },

    // 删除
    deleteRow() {
      this.close();
      this.showDel = true;
    },
    // 确定删除
    async confirmDel() {
      const folderId = this.Pitem.folderId;
      await docService.queryDeleteFile([folderId]);
      Notify({ type: "success", message: "删除成功!" });
      this.showDel = false;
      this.$emit("toRefresh");
    },
    // 重命名
    rename() {
      if (this.Pitem.isFolder === 1) {
        this.renameValue = this.Pitem.folderName;
      } else {
        const typeIndex = this.Pitem.folderName.lastIndexOf(".");
        const newName = this.Pitem.folderName.substring(0, typeIndex);
        this.renameValue = newName;
      }
      this.close();
      this.renameShow = true;
    },
    // 确定重命名
    async confirmRename() {
      const nameLength = this.renameValue.replace(/\s*/g, "");
      if (!nameLength) {
        return Notify({ type: "warning", message: "名称不能为空且不超过80个字符" });
      }
      if (nameLength.length > 80) {
        return Notify({ type: "warning", message: "名称不能超过80个字符" });
      }
      const regExp = new RegExp('[\\\\|/:*<>?"]');
      if (regExp.test(nameLength)) {
        return Notify({ type: "warning", message: '文件夹名称不能包含以下字符:\\ / : * " ? < > |' });
      }
      // 参数
      let name = nameLength;
      const { folderId, isFolder } = this.Pitem;
      if (isFolder === 0) {
        const fileTypeArr = this.Pitem.folderName.split(".");
        name = `${name}.${fileTypeArr[fileTypeArr.length - 1]}`;
      }
      const params = {
        id: folderId,
        name,
        isFolder,
        remark: "",
        prjId: this.enterpriseId
      };
      await docService.renameMyDoc(params);
      Notify({ type: "success", message: "重命名成功!" });
      this.renameShow = false;
      this.$emit("toRefresh");
    },
    // 属性
    queryAttribute() {
      this.close();
      this.attributeShow = true;
    },
    // 关闭属性
    attributeClose() {
      this.attributeShow = false;
    },
    // 下载文件
    async downloadDoc(row) {
      const prjId = "MyDoc";
      const { userId } = this.userInfo || {};
      if (row.isFolder !== 1) {
        const fileId = row.folderId;
        const version = row.fileVersion;
        const downzipurl = downloadUrltoken(prjId, fileId, version);
        downloadFile(downzipurl);
      } else {
        const params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        docService.downloadfolder(params).then((response) => {
          const fileName = row.folderName + ".zip";
          downloadFileShowPrompt(fileName, response);
        });
      }
    },
    // 添加收藏
    async addCollect() {
      const { folderId, folderName, isFolder } = this.Pitem || {};
      const params = {
        folderId,
        folderName,
        isFolder,
        prjId: "MyDoc",
        enterpriseId: this.enterpriseId
      };
      await docService.addPersonFavorite(params);
      Notify({ type: "success", message: "已成功收藏" });
      this.close();
      this.$emit("toRefresh");
    },

    // 移动到
    moveTo() {
      this.selectArr = [this.Pitem.folderId];
      this.close();
      this.moveShow = true;
    },
    // 移动取消
    moveCancel() {
      this.moveShow = false;
      this.selectArr = [];
    },
    // 移动确定
    async moveConfirm() {
      if (this.currentFolderId) {
        if (this.currentFolderId === this.Pitem.parentId) {
          return Notify({ type: "warning", message: "文档已在当前目录下!" });
        }
        if (this.currentFolderId === this.userInfo.userId) {
          return Notify({ type: "warning", message: "不能移动到当前目录下!" });
        }
        const params = {
          ids: this.selectArr,
          prjId: "MyDoc",
          enterpriseId: this.enterpriseId,
          parentId: this.currentFolderId
        };
        await docService.moveFile(params);
        Notify({ type: "success", message: "移动成功!" });
        this.closeMoveCopy();
        this.$emit("toRefresh");
      }
    },
    // 复制到
    copyTo() {
      this.selectArr = [this.Pitem.folderId];
      this.close();
      this.copyShow = true;
    },
    // 复制取消
    copyCancel() {
      this.copyShow = false;
      this.selectArr = [];
    },
    // 复制确定
    async copyConfirm() {
      if (this.currentFolderId) {
        if (this.currentFolderId === this.Pitem.parentId) {
          return Notify({ type: "warning", message: "文档已在当前目录下!" });
        }
        if (this.currentFolderId === this.userInfo.userId) {
          return Notify({ type: "warning", message: "不能复制到当前目录下!" });
        }
        const params = {
          ids: this.selectArr,
          prjId: "MyDoc",
          enterpriseId: this.enterpriseId,
          parentId: this.currentFolderId
        };
        await docService.copyFile(params);
        Notify({ type: "success", message: "复制成功!" });
        this.closeMoveCopy();
        this.$emit("toRefresh");
      }
    },

    // 分享
    async shareDoc() {
      this.shareLink = {}; // 清空分享链接数据
      const prjId = "MyDoc"; // 个人文档
      const endDate = getDateTime(null, "y-m-d h:m:s", 1); // 默认为一天后
      const { folderId, isFolder, folderName } = this.Pitem;
      const file = { id: folderId, isFile: isFolder, name: folderName };
      const params = {
        prjId,
        enterpriseId: this.enterpriseId,
        folderList: [file],
        isNeedPwd: 1, // 普通链接和二维码不需要密码   0是需要密码
        endDate: endDate,
        isDownload: 1, // 允许下载
        isEdit: 1,
        title: folderName,
        isOut: 1,
        shareSource: 1 // 个人文档为1  企业文档为2
      };
      const res = await docService.genShareNewLink(params);
      this.shareLink = res.data || {};
      this.close();
      this.shareShow = true;
    },
    // 分享弹框打开
    shareOpen() {
      this.$nextTick(() => {
        this.$refs.qrcode.qrCreate(this.shareLink.url);
      });
    },
    // 保存二维码到相册
    saveQrcode() {
      this.$refs.qrcode.qrSave();
    },
    // 复制链接
    copyUrl(url) {
      if (url) {
        this.$copyText(url).then(() => {
          Notify({ type: "success", message: "链接复制成功!" });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .uActionSheetStyle {
  .van-action-sheet__content {
    max-height: 50vh;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #e5e8f1 !important;
    .van-action-sheet__name {
      font-size: 16px;
      color: var(--key-color);
    }
  }

  .van-action-sheet__cancel {
    font-size: 16px;
    color: #007af5;
  }

  .van-action-sheet__gap {
    height: 1px !important;
    background-color: #e5e8f1 !important;
  }
}

.modalStyle {
  width: 90vw;
  padding: 3vh 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .buttonSlider {
    width: 100%;
    padding: 2vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

.modalRenameStyle {
  width: 90vw;
  padding: 0 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .input {
    border: 1px solid #e5e8f1 !important;
    background: #f5f5f5;
  }

  .buttonSlider {
    width: 100%;
    padding: 3vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

.attributeContent {
  max-height: 240px;
  padding: 20px;

  .attributeItem {
    white-space: nowrap;
    overflow: overlay !important;
    overflow: auto;
    span {
      font-size: 16px;
      line-height: 40px;
    }
    .attributeItemData {
      color: var(--key-color);
    }
  }
}

.attributeClose {
  border-top: 1px solid #e5e8f1 !important;
  font-size: 16px !important;
  color: #007af5 !important;
  line-height: 50px;
  text-align: center;
}

.moveToPopup {
  .moveTo {
    width: 100vw;
    padding: 2vh 5vw;
    display: flex;
    justify-content: space-around;

    .van-button {
      width: 40%;
    }
  }
}

.shareStyle {
  width: 100vw;
  padding: 30px 5vw 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .van-button {
    width: 120px;
    margin-top: 20px;
  }

  .linkText {
    width: 100%;
    margin-top: 20px;
    font-size: 14px;
    color: var(--key-color);
    word-break: break-all;
  }

  .linkBtn {
    margin-top: 20px !important;
    font-size: 14px;
    color: #007af5;
    cursor: pointer;
  }
}
</style>
